export enum AquaSpecies {
  salmon = 'salmon',
  shrimp = 'shrimp',
}
